import {TableColumnsType} from "antd";
import {CashPeriodDataInterface} from "../CashPeriod.interface";
import {formatKorDate} from "../../../util/date";
import styles from "../CashPeriod.module.scss";
import {formatNumber} from "../../../util/format";
import React from "react";

const Columns: TableColumnsType<CashPeriodDataInterface> = [
	{
		title: '날짜',
		dataIndex: 'updateDate',
		key: 'updateDate',
		width: 150,
		align: 'center',
		// className: styles.blackBackground,
		render: (text: string) => <div>{formatKorDate(text)}</div>,
	},
	{
		title: '입금',
		dataIndex: 'depositDoneSum',
		key: 'depositDoneSum',
		width: 150,
		align: 'center',
		className: styles.blueBackground,
		render: (text: string) => (
			<div style={{ textAlign: 'right' }}>
				{formatNumber(Number(text), 'KRW')}
			</div>
		),
	},
	{
		title: '출금',
		dataIndex: 'withdrawalDoneSum',
		key: 'withdrawalDoneSum',
		width: 150,
		align: 'center',
		className: styles.redBackground,
		render: (text: string) => (
			<div style={{ textAlign: 'right' }}>
				{formatNumber(Number(text), 'KRW')}
			</div>
		),
	},
	{
		title: '미승인 입금',
		dataIndex: 'depositHoldSum',
		key: 'depositHoldSum',
		width: 150,
		align: 'center',
		// className: styles.blueBackground,
		render: (text: string) => (
			<div style={{ textAlign: 'right' }}>
				{formatNumber(Number(text), 'KRW')}
			</div>
		),
	},
	{
		title: '미승인 출금',
		dataIndex: 'withdrawalHoldSum',
		key: 'withdrawalHoldSum',
		width: 150,
		align: 'center',
		// className: styles.redBackground,
		render: (text: string) => (
			<div style={{ textAlign: 'right' }}>
				{formatNumber(Number(text), 'KRW')}
			</div>
		),
	},
	// {
	// 	title: '이벤트 입금',
	// 	dataIndex: 'eventDepositDoneSum',
	// 	key: 'eventDepositDoneSum',
	// 	width: 150,
	// 	align: 'center',
	// 	className: styles.blueBackground,
	// 	render: (text: string) => (
	// 		<div style={{ textAlign: 'right' }}>
	// 			{formatNumber(Number(text), 'KRW')}
	// 		</div>
	// 	),
	// },
];

export default Columns;
